var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('participants',{staticClass:"block participants",attrs:{"loading":_vm.isLoading,"participants":_vm.participants,"number-of-less-participants":7,"lazy":false},on:{"toggleSidebar":_vm.toggleSidebar}})}
var staticRenderFns = []

export { render, staticRenderFns }